<template>
  <nav class="panel">
    <p class="panel-heading">
      Order overview
      <b-button style="float: right;" size="is-small" v-on:click="openEditDestinationModal">
        <b-icon pack="fas" icon="pencil-alt" size="is-small"/>
      </b-button>
    </p>
    <div class="panel-block order-overview">
      <table class="table is-fullwidth">
        <tbody>
          <tr v-if="this.$store.getters['cart/country']">
            <td>Country</td>
            <td class="has-text-right">
              {{$store.getters['cpOrder/countryName']}}
            </td>
          </tr>
          <tr v-if="this.$store.getters['cart/state']">
            <td>State</td>
            <td class="has-text-right">
              {{$store.getters['cpOrder/stateName']}}
            </td>
          </tr>
          <tr v-if="priceCheck">
            <td>Order price</td>
            <td class="has-text-right">
              {{priceCheck.subtotals.items | currency(priceCheck.currency)}}
            </td>
          </tr>
          <tr v-if="priceCheck && parseFloat(priceCheck.subtotals.fee) > 0.0000 ">
            <td>Fee</td>
            <td class="has-text-right">
              {{priceCheck.subtotals.fee | currency(priceCheck.currency)}}
            </td>
          </tr>
          <tr>
            <td>VAT</td>
            <td class="has-text-right">
              <span v-if="maxShippingVAT === 0 && priceCheck.vat === 0">
                  Free
              </span>
              <span v-else-if="minShippingVAT == maxShippingVAT">
                {{minShippingVAT + parseFloat(priceCheck.vat) | currency(priceCheck.currency)}}
              </span>
              <span v-else>
                From {{minShippingVAT + parseFloat(priceCheck.vat) | currency(priceCheck.currency)}} to {{maxShippingVAT + parseFloat(priceCheck.vat) | currency(priceCheck.currency)}}
              </span>

            </td>
          </tr>
          <tr>
            <td>Shipping price</td>
            <td class="has-text-right">
              <span v-if="maxShippingPrice === 0">
                  Free
              </span>
              <span v-else-if="minShippingPrice == maxShippingPrice">
                {{minShippingPrice | currency(priceCheck.currency)}}
              </span>
              <span v-else>
                From {{minShippingPrice | currency(priceCheck.currency)}} to {{maxShippingPrice | currency(priceCheck.currency)}}
              </span>

            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <EditCountryModal :isComponentModalActive="isComponentModalActive"/>

  </nav>
</template>

<script>
import _ from 'lodash'

import EditCountryModal from '@/components/EditCountryModal'
import EventBus from '@/event-bus'
import AddressMixin from '@/mixins/AddressMixin'

export default {
  name: 'OrderOverview',
  mixins: [AddressMixin],
  props: {
    priceCheck: Object
  },
  components: {
    EditCountryModal
  },
  data () {
    return {
      isComponentModalActive: false,
      minShippingPrice: 0,
      maxShippingPrice: 0,
      minShippingVAT: 0,
      maxShippingVAT: 0
    }
  },
  created () {
    this.getCountryList()

    document.addEventListener('keyup', event => {
      if (event.keyCode === 27) {
        this.isComponentModalActive = false
      }
    })
  },
  mounted () {
    EventBus.$on('EditCountryModal-modal-close', () => {
      this.isComponentModalActive = false
      this.getStates()
    })
  },
  watch: {
    priceCheck: function () {
      if (this.priceCheck) {
        let minShippingPrice = 0
        let maxShippingPrice = 0

        let minShippingVAT = 0
        let maxShippingVAT = 0
        for (let shipment of this.priceCheck.shipments) {
          let prices = []
          let vats = []

          for (let quote of shipment.quotes) {
            prices.push(parseFloat(quote.price))
            vats.push(parseFloat(quote.vat))
          }

          minShippingPrice += _.min(prices)
          maxShippingPrice += _.max(prices)

          minShippingVAT += _.min(vats)
          maxShippingVAT += _.max(vats)
        }

        this.minShippingPrice = minShippingPrice
        this.maxShippingPrice = maxShippingPrice

        this.minShippingVAT = minShippingVAT
        this.maxShippingVAT = maxShippingVAT
      }
    }
  },
  methods: {
    openEditDestinationModal: function () {
      this.isComponentModalActive = true
    }
  }
}
</script>
